/*
 * Copyright (C) Schweizerische Bundesbahnen SBB, 2018.
 */

import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DetailFormDataModel } from '../../../../config/model/detail-form-data.model';
import { DetailViewComponent } from '../../detail-view.component';
import { Observable } from 'rxjs';
import { LayerQueryService } from 'src/app/shared/service/layer-query.service';
import {LayerCode} from "../../../../shared/enum/layer-code.enum";

// text,email,tel,textarea,password,
@Component({
    selector: 'text-view-bp',
    templateUrl: './text-view-bp.component.html',
    styleUrls: ['./text-view-bp.component.scss'],
    standalone: false
})
export class TextViewBpComponent implements OnInit {
  @Input() prop: any = {};
  @Input() graphicFormGroup: UntypedFormGroup;
  @Input() detailFormDataModel: DetailFormDataModel;
  @ViewChild('inputFieldRef', { static: false }) inputFieldRef: ElementRef;

  public displayValue = '-';

  constructor(
    public _detailViewComponent: DetailViewComponent,
    private layerQueryService: LayerQueryService
  ) {}

  ngOnInit() {
    this.getDisplayValue();
  }

  private getDisplayValue() {
    const bpNr = this.detailFormDataModel.selectedFeature.attributes[this.prop.field_name];
    this.getBetriebspunktName(bpNr).subscribe(response => {
      if (response) this.displayValue = response.features[0].attributes['BEZEICHNUNG'];
    });
  }

  getBetriebspunktName(bpNr: string): Observable<any> {
    return this.layerQueryService.featuresFromLayer(LayerCode.f_betriebspunkt, `ID=${bpNr}`, ['BEZEICHNUNG']);
  }
}
